<template>
  <div class="notifications-panel-actions">
    <LLOptionsList :open.sync="opened" :offset="[0, 0]" placement="bottom-end">
      <template #trigger>
        <LLButton small tertiary-dark>
          <template #icon-left>
            <OptionsIcon v-if="!isPending" />
            <LLLoader v-else class="notifications-item-actions__loader"></LLLoader>
          </template>
        </LLButton>
      </template>
      <template #buttons>
        <LLOptionsListButton small @click="markAllRead">
          {{ $t('notifications.bulk_actions.mark_as_read') }}
        </LLOptionsListButton>
        <LLOptionsListButton v-if="selectedTab !== 'unread'" small @click="clearAllRead">
          {{ $t('notifications.bulk_actions.clear_all_read') }}
        </LLOptionsListButton>
        <router-link to="/notifications" tag="a">
          <LLOptionsListButton small @click="$emit('close')">
            {{ $t('notifications.bulk_actions.view_history') }}
          </LLOptionsListButton>
        </router-link>
      </template>
    </LLOptionsList>
  </div>
</template>

<script>
import LLButton from '@/components/common/ui-components/LLButton.vue'
import LLOptionsListButton from '@/components/common/LLOptionsList/LLOptionsListButton.vue'
import LLOptionsList from '@/components/common/LLOptionsList.vue'
import OptionsIcon from '@/assets/icons/OptionsIcon.vue'
import LLLoader from '@/components/common/LLLoader.vue'

export default {
  name: 'NotificationsPanelActions',
  components: { LLLoader, OptionsIcon, LLOptionsList, LLOptionsListButton, LLButton },
  props: {
    selectedTab: { type: String, required: true }
  },
  data() {
    return {
      isPending: false,
      opened: false
    }
  },
  methods: {
    async markAllRead() {
      this.opened = false
      try {
        this.isPending = true
        await this.$api.notifications.markAllAsRead()
        this.isPending = false
      } catch (e) {
        console.error(e)
      }
      this.isPending = false
    },
    async clearAllRead() {
      this.opened = false
      try {
        this.isPending = true
        await this.$api.notifications.clearAllRead()
      } catch (e) {
        console.error(e)
      }
      this.isPending = false
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-panel-actions {
}
</style>
